module.exports = "https://static.energy5.com/_next/static/images/did-you-know-f8487e28579923a2110557a5f6f71aa0.png";